<template>
    <div class="d-flex w-100">
      <div v-if="!details" class="d-flex w-100">
        <div class="col-md-3">
          <registerFilter  @search="search"></registerFilter>
        </div>
        <div class="col-md-9">
            <registerTable ref="registerTable" @detalhesDespesa="detalhesApr"></registerTable>
        </div>
      </div>
    </div>
  </template>

<script>
import registerApr from './registerApr'
export default registerApr
</script>

<style scoped>
.col-md-3{
padding-right: 0;
padding-left: 0;
}
</style>



// WEBPACK FOOTER //
// src/views/private/apr/registerApr/registerApr.vue